import React from 'react';
import { Analytics } from 'packages';

const handleArrowClick = (pageType, direction) => {
    Analytics.trackEvent({
        category: pageType,
        action: `Carousel:${direction}`
    });
};

export const NextArrow = props => {
    const { className, style, onClick, pageType } = props;
    return (
        <div
            className={`arrow ${className}`}
            style={{ ...style, display: 'block' }}
            onClick={() => {
                onClick();
                handleArrowClick(pageType, 'Next');
            }}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16">
                <g fill="none" fillRule="evenodd">
                    <path
                        fill="#2D3742"
                        d="M5.602 0a.4.4 0 0 1 .232.092l7.403 7.654c.155.16.155.32 0 .48L5.834 15.88c-.155.16-.31.16-.465 0l-2.253-2.33c-.155-.16-.155-.32 0-.48l4.917-5.084-4.917-5.084c-.155-.16-.155-.32 0-.48L5.37.092A.4.4 0 0 1 5.602 0z"
                    />
                </g>
            </svg>
        </div>
    );
};
export const PreviousArrow = props => {
    const { className, style, onClick, pageType } = props;
    return (
        <div
            className={`arrow ${className}`}
            style={{ ...style, display: 'block' }}
            onClick={() => {
                onClick();
                handleArrowClick(pageType, 'Previous');
            }}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16">
                <g fill="none" fillRule="evenodd">
                    <path
                        fill="#2D3742"
                        d="M10.401 16a.4.4 0 0 1-.232-.092L2.766 8.254c-.155-.16-.155-.32 0-.48L10.17.12c.155-.16.31-.16.465 0l2.253 2.33c.155.16.155.32 0 .48L7.952 8.014l4.935 5.084c.155.16.155.32 0 .48l-2.253 2.33A.4.4 0 0 1 10.4 16z"
                    />
                </g>
            </svg>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/carousels/arrows.jsx